/**
 * Generates a CSS linear gradient string based on the provided option and theme.
 *
 * @param option - The gradient option to use. Can be one of "soft-pink", "light-blue", "deep-blue", "forest-green", or "text".
 * @param theme - The theme object containing palette information.
 * @returns A string representing the CSS linear gradient.
 */
const getGradient = (
  option: "soft-pink" | "light-blue" | "deep-blue" | "forest-green" | "text",
  theme: any,
) => {
  if (option === "soft-pink") {
    return `linear-gradient(45deg, #dfadeba1, #fadfb665)`;
  } else if (option === "light-blue") {
    return `linear-gradient(45deg, rgba(${theme.palette.primary[500]}, 1), rgba(${theme.palette.primary[200]}, 1))`;
  } else if (option === "deep-blue") {
    return `linear-gradient(45deg, rgba(${theme.palette.primary.mainChannel}, 1), rgba(${theme.palette.primary.mainChannel}, 1))`;
  } else if (option === "forest-green") {
    return `linear-gradient(45deg, rgba(${theme.palette.primary.mainChannel}, 1), rgba(${theme.palette.primary.mainChannel}, 1), rgba(${theme.palette.primary.mainChannel}, 1))`;
  } else if (option === "text") {
    return `linear-gradient(45deg, rgba(${theme.palette.primary[50]}, 1), rgba(${theme.palette.primary[600]}, 1))`;
  }
};

export const Gradients = { getGradient };
